import apiClient from './api';

class ProfileService {
  async getProfile() {
    try {
      const response = await apiClient.get('/profile');
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch profile.';
    }
  }

  async updateProfile(dto) {
    try {
      const response = await apiClient.put('/profile', dto);
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update profile.';
    }
  }

  async changePassword(dto) {
    try {
      const response = await apiClient.put('/profile/change-password', dto);
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to change password.';
    }
  }
}

export default new ProfileService();
